import messagesActions from '../actions/MessagesActions';

const uuid = require('uuid');

export default function (state = { items: [] }, action) {
    switch (action.type) {
    case messagesActions.types.MESSAGES_UPDATED:
        action.message.messageId = uuid.v4();
        return Object.assign({}, state, {
            items: [
                ...state.items || [],
                action.message,
            ],
        });
    case messagesActions.types.ALL_MESSAGES_LOADED:
        return Object.assign({}, state, { items: action.messages });
    default:
        return state;
    }
}
